import store from '../store';
import tempMee, { callAuthServiceApi } from '../apis/tempMee';
import {
  AUTH_SIGN_IN_REQUEST,
  AUTH_SIGN_IN_FAILURE,
  AUTH_SIGN_IN_SUCCESS,
  AUTH_REFRESH_SUCCESS,
  AUTH_REFRESH_REQUEST,
  AUTH_REFRESH_FAILURE,
  AUTH_SIGN_IN_GOOGLE_REQUEST,
  AUTH_SIGN_IN_GOOGLE_SUCCESS,
  AUTH_SIGN_IN_GOOGLE_FAILURE,
  USER_ACTIONS,
} from './actionTypes';
import { isValidTokenKey, reverseHex } from '../utils';
import { growthbook } from '../growthbook';
import PosthogService from '../services/posthog/PosthogService';
import { clearPosthogIdentifyCache } from '../utils/posthog/identify';

export const callRefreshToken = () => {
  const refreshToken = localStorage.getItem('refresh_token');

  return callAuthServiceApi('post', 'sessions/refresh', { refreshToken });
};

export const refresh = () => async (dispatch) => {
  try {
    dispatch({ type: AUTH_REFRESH_REQUEST });

    if (!isValidTokenKey()) {
      // force logout
      dispatch(logout());
    }

    const response = await callRefreshToken();

    dispatch({
      type: AUTH_REFRESH_SUCCESS,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: AUTH_REFRESH_FAILURE,
      payload: err,
    });
  }
};

export const getAuthHeaders = async () => {
  const authState = store.getState().auth;
  if (!authState.expirationDate || store.getState().auth.expirationDate < new Date()) {
    const response = await callRefreshToken();

    store.dispatch({
      type: AUTH_SIGN_IN_SUCCESS,
      payload: response.data,
    });
  }

  // eslint-disable-next-line camelcase
  const { access_token } = store.getState().auth;
  // eslint-disable-next-line camelcase
  return { Authorization: access_token };
};

export const getAuthServiceHeaders = async () => {
  const authState = store.getState().auth;
  if (!authState.expirationDate || store.getState().auth.expirationDate < new Date()) {
    const response = callRefreshToken();

    store.dispatch({
      type: AUTH_SIGN_IN_SUCCESS,
      payload: response.data,
    });
  }

  const { access_token: at } = store.getState().auth;

  return { Authorization: `Bearer ${at}` };
};

export const signIn =
  ({ email, password }) =>
  async (dispatch) => {
    try {
      dispatch({ type: AUTH_SIGN_IN_REQUEST });
      const turnstileToken = process.env.REACT_APP_TURNSTILE_TOKEN;
      const response = await tempMee.post('/admin/auth/signin', {
        email,
        password,
        ...(turnstileToken && { turnstileToken }),
      });

      dispatch({
        type: AUTH_SIGN_IN_SUCCESS,
        payload: response.data,
      });
    } catch (err) {
      dispatch({
        type: AUTH_SIGN_IN_FAILURE,
        payload: err,
      });
    }
  };

export const signInWithGoogle = (hexToken) => async (dispatch) => {
  try {
    dispatch({ type: AUTH_SIGN_IN_GOOGLE_REQUEST });

    const payload = reverseHex(hexToken);

    dispatch({
      type: AUTH_SIGN_IN_GOOGLE_SUCCESS,
      payload: {
        access_token: payload?.access_token || payload?.accessToken,
        refresh_token: payload?.refresh_token || payload?.refreshToken,
        expires_in: payload?.expires_in || payload?.expiresIn,
      },
    });
  } catch (err) {
    dispatch({
      type: AUTH_SIGN_IN_GOOGLE_FAILURE,
      payload: err,
    });
  }
};

export const logout = () => async (dispatch) => {
  try {
    dispatch({ type: AUTH_SIGN_IN_REQUEST });
    const headers = await getAuthHeaders();
    await tempMee.post('/auth/logout', {}, { headers, withCredentials: true });

    growthbook.setAttributes({});
    // Clear cached identify properties before resetting PostHog
    const adminUser = store.getState()?.users?.adminUser;
    clearPosthogIdentifyCache(adminUser?.id);
    PosthogService.getInstance().reset();
    dispatch({ type: USER_ACTIONS.RESET_CURRENT_LOGIN_USER });
    dispatch({ type: USER_ACTIONS.RESET_UNFINISHED_USER_LIST_SEARCH });
    dispatch({ type: USER_ACTIONS.RESET_DSO_LIST_SEARCH });
    dispatch({ type: USER_ACTIONS.RESET_DENTIST_LIST_SEARCH });
    dispatch({ type: USER_ACTIONS.RESET_HYGIENIST_LIST_SEARCH });

    dispatch({
      type: AUTH_SIGN_IN_SUCCESS,
      payload: {},
    });
  } catch (err) {
    dispatch({
      type: AUTH_SIGN_IN_FAILURE,
      payload: err,
    });
  }
};
